<template>
  <div class="time-picker">
    <!-- Hour Selector -->
    <div class="picker">
      <button class="arrow" v-bind="$attrs" @click.prevent="changeValue(1)">▲</button>
      <div class="display">{{ displayValue }}</div>
      <button class="arrow" v-bind="$attrs" @click.prevent="changeValue(-1)">▼</button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'p-slider',
  data() {
    return {
      minuteSteps: [15, 20, 25, 30, 35, 40, 45, 50, 55], // Steps of 5 minutes
    };
  },
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    // value prop now comes from modelValue computed
    mode: {
      type: String,
      default: "hour", // "hour" or "minute"
    },
  },
  computed: {
    value() { return this.modelValue; },
    displayValue() {
        if(this.value)
        {
            return this.value.toString().padStart(2, "0");  
        }      
        return "00";
    },
  },
  methods: {
    changeValue(step) {
      let newValue = this.value;
      
      if (this.mode === "hour") {
        // Exclude 0 — "occurs every 0 hours" is invalid. Wrap between 1 and 23.
        newValue = ((this.value - 1 + step + 23) % 23) + 1;
      }
      else if (this.mode === "minute") 
      {
        let currentIndex = this.minuteSteps.indexOf(this.value);
        let newIndex = (currentIndex + step + this.minuteSteps.length) % this.minuteSteps.length;
        newValue = this.minuteSteps[newIndex];
      }

      this.$emit("update:modelValue", newValue);
      this.$emit("input", newValue);
    },
  },
};
</script>

<style scoped>
.time-picker {
  display: flex;
}

.picker {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.9em;
  max-width: 50px;
  width: 90%;
  justify-content: space-between;
  background: #f5f5f5;
  border-radius: 10px;
  padding: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  position: relative;
}

.label {
  font-weight: bold;
  margin-bottom: 5px;
}

.display {
  font-size: 20px;
  font-weight: bold;
  color: #343a40;
  flex-grow: 1;
  max-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0px;
  color: #333;
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px; 
  height: 24px;
  font-size: 1.3em;
  margin: 2px 0;
}

.arrow:hover {
  color: #343a40;
  transform: scale(1.2);
}
</style>
